"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPricedOffers = exports.GET_PRICED_OFFERS_PATH = void 0;
const utils_1 = require("@invivodf/utils");
const utils_2 = require("../../../utils");
exports.GET_PRICED_OFFERS_PATH = `/v1/bff/appro/price-offers`;
const getPricedOffers = (client) => async (params) => {
    try {
        const response = await client.post(exports.GET_PRICED_OFFERS_PATH, params);
        return utils_1.Result.success(response.data);
    }
    catch (error) {
        if ((0, utils_2.isFunctionalApiError)(error)) {
            return utils_1.Result.failure({
                code: error.body.code,
                message: error.body.message
            });
        }
        throw error;
    }
};
exports.getPricedOffers = getPricedOffers;
